module.exports = __webpack_public_path__ + "static/assets/8e637b4e1bc1aeca8229b3cfa622df3c.gif";